import { createFileRoute, Outlet } from '@tanstack/react-router'
import { v2CreateFeedback } from '@workspace/api-backend'
import { createContext, useCallback, useContext, useState } from 'react'
import { FeedbackDialog } from '../components/feedback-dialog'
import { AppRouteGuard } from '../contexts/app-guard'

// ─── Feedback context ────────────────────────────────────────────────────────

export const FeedbackContext = createContext<(() => void) | null>(null)

export function useFeedback() {
  const open = useContext(FeedbackContext)
  if (!open) throw new Error('useFeedback must be used within AppLayout')
  return open
}

// ─── Route ───────────────────────────────────────────────────────────────────

export const Route = createFileRoute('/app')({
  component: AppLayout,
})

function AppLayout() {
  const [feedbackOpen, setFeedbackOpen] = useState(false)

  const openFeedback = useCallback(() => setFeedbackOpen(true), [])

  async function handleFeedbackSubmit(data: {
    message: string
    pageUrl: string
    userAgent: string
  }) {
    await v2CreateFeedback({ body: data })
  }

  return (
    <FeedbackContext.Provider value={openFeedback}>
      <AppRouteGuard>
        <Outlet />
        <FeedbackDialog
          open={feedbackOpen}
          onOpenChange={setFeedbackOpen}
          onSubmit={handleFeedbackSubmit}
        />
      </AppRouteGuard>
    </FeedbackContext.Provider>
  )
}
